(async () => {
    const { Core } = await importModule('Core');

    customElements.define('cart-total', class extends Core {
        subscriptions = {
            'cart:update': '_cartUpdateHandler'
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            this.publish('cart:add-feature', { feature: 'cart-total' });
            this.subscribe('cart:update', { global: true });
        }

        _cartUpdateHandler({ meta }) {
            console.log('[Cart Total] Received cart:update with meta:', meta);
            if (meta && typeof meta.total !== 'undefined') {
                 this.total = meta.total;
            } else {
                 console.warn('[Cart Total] cart:update meta missing or meta.total is undefined.');
            }
        }

        set total(value) {
            console.log('[Cart Total] Setter received raw value:', value, '(type:', typeof value, ')');
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                const moneyFormat = window.Shopify?.money_format || '${{amount}}';
                try {
                    const formattedValue = Shopify.formatMoney(value, moneyFormat);
                    console.log('[Cart Total] Formatted value:', formattedValue);
                    this.textContent = formattedValue;
                } catch (e) {
                     console.error('[Cart Total] Error formatting money:', e);
                     this.textContent = value; // Fallback on error
                }
            } else {
                console.warn('[Cart Total] Shopify.formatMoney not found. Displaying raw value.');
                this.textContent = value; 
            }
        }
    });
})()